import lang from '../../../lib/language';

import facebookIcon from '../../../assets/img/icon-share-facebook.svg';
import linkedinIcon from '../../../assets/img/icon-share-linkedin.svg';
import whatsappIcon from '../../../assets/img/icon-share-whatsapp.svg';
import xIcon from '../../../assets/img/icon-share-x.svg';
import { SocialNetworkEnum } from '../../../containers/Referrals/Referrals.types';

export const QR_CODE_SIZE = 200;
export const QR_CODE_DATA_URI_PREFIX = 'data:image/png;base64, ';
export const SHARE_MODAL_WIDTH = 420;

export const SOCIAL_NETWORKS = [
  { network: SocialNetworkEnum.facebook, icon: facebookIcon, ariaLabel: lang.referralsShareViaFacebook() },
  { network: SocialNetworkEnum.x, icon: xIcon, ariaLabel: lang.referralsShareViaX() },
  { network: SocialNetworkEnum.linkedin, icon: linkedinIcon, ariaLabel: lang.referralsShareViaLinkedin() },
  { network: SocialNetworkEnum.whatsapp, icon: whatsappIcon, ariaLabel: lang.referralsShareViaWhatsapp() },
];
